import { DashBoardMenuName, MetaEntity, SingleMenuItem } from '../types';

export const generateMenuItems = (meta: MetaEntity): SingleMenuItem[] => {
	const formMenuItems = meta.tabs.map((tab) => ({
		name: tab.name,
		value: 0,
		totalValue: tab.groups.reduce((acc, current) => {
			return (acc += current.properties.length);
		}, 0),
	}));

	return [
		{
			name: DashBoardMenuName.welcome,
			value: null,
			totalValue: null,
		},
		...formMenuItems,
		{
			name: DashBoardMenuName.submitForRating,
			value: null,
			totalValue: null,
		},
	];
};
